export default "__VITE_PUBLIC_ASSET__38a50bc1__"